import axios from "axios";
import { createFormHeadersAdmin, createHeadersAdmin } from "../../utils/Utils";
import { BASE_URL } from "../../assets/constants/constants";

//! *******************************************************
//! ********************Drop Downs*************************
//! *******************************************************

//  class
export const getLMSDashboardDataAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}lms-dashboard`, data, headers);
};



//  total students
export const getTotalStudentListAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}student-list`, data, headers);
};
//  total approved students
export const getApprovedStudentListAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}approved-student-list`, data, headers);
};
//  pending students
export const getPendingStudentListAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}pending-student-list`, data, headers);
};
//  change students
export const getChangeStudentListAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}change-required-student-list`, data, headers);
};
//  rejected students
export const getRejectedStudentListAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}rejected-student-list`, data, headers);
};
//  Subject students
export const getSubjectStudentListAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.post(`${BASE_URL()}subject-student-list`, data, headers);
};